module.exports = __webpack_public_path__ + "static/media/nav-hospitalD.73cf29f9.png";